/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { ActivityItemComponent } from '../../activity-feed/activity-item.component';
import { DashboardComponent } from './dashboard.component';
import { DashboardActivityCardComponent } from './activity-card/dashboard-activity-card.component';
import { DashboardProjectRowComponent } from './project-row/dashboard-project-row.component';
import { DashboardChecklistComponent } from './checklist/dashboard-checklist.component';
import { DashboardProfileCompletionComponent } from './profile-completion/dashboard-profile-completion.component';
import { DashboardMyDevicesComponent } from './my-devices/dashboard-my-devices.component';
import { DashboardRequestedDevicesComponent } from './requested-devices/dashboard-requested-devices.component';
import { ScrollFocusDirective } from './shared/scroll-focus.directive';
import { TimeLeftPipe } from './shared/time-left.pipe';

// The logged-in Home page in the 2026 design, downgraded as utDashboard for <home>.
@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    ActivityItemComponent,
    ScrollFocusDirective,
    TimeLeftPipe,
  ],
  declarations: [
    DashboardComponent,
    DashboardActivityCardComponent,
    DashboardProjectRowComponent,
    DashboardChecklistComponent,
    DashboardProfileCompletionComponent,
    DashboardMyDevicesComponent,
    DashboardRequestedDevicesComponent,
  ],
  exports: [DashboardComponent],
})
export class DashboardModule {}
